import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SliderModelService } from '../../../services/infrastructure/sliderModel.service';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { DatePipe } from '@angular/common';
import { MasterConstants } from '../../../common/constants/master-constants';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';
import { GrowerProgramService } from '../../../services/seed/growerProgram.service';

@Component({
    selector: 'app-grower-program-comment',
    templateUrl: './grower-program-comment.component.html',
    styleUrls: ['./grower-program-comment.component.scss']
})
export class GrowerProgramCommentComponent implements OnInit, OnDestroy {
    subscription = new Array<Subscription>();
    displayedColumns: string[] = [
        'date',
        'userName',
        'comment',
    ];
    newCommentColumns: string[] = [
        'comment'
    ];
    commentDataSource: any[];
    selectedElement: any;
    selectedRowId: number = 0;
    commentData: any;
    newComment: any;
    isNewComment: boolean = false;
    btnText = 'Add New Comment';
    isInvalid: boolean = false;
    isDisabled: boolean = true;
    constructor(private sliderModelService: SliderModelService,
        private loaderService: LoaderService,
        private localStorageService: LocalStorageService,
        private datePipe: DatePipe,
        private growerProgramService: GrowerProgramService) { }

    ngOnInit(): void {
        this.loaderService.setLoaderStatus(true);
        this.subscription.push(this.sliderModelService.initializegpCommentSliderValue.subscribe(commentData => {
            if (commentData.spendID > 0) {
                this.commentData = commentData;
                this.isDisabled = commentData.isSpendDisabled;
                this.loadCommentGrid();
            }
            this.loaderService.setLoaderStatus(false);
        }));
        this.subscription.push(this.sliderModelService.sliderCloseRqt.subscribe(result => {
            if (result) {
                this.resetCommentGridData();
            }
        }));
    }

    commentClick() {
        this.isInvalid = false;
        if (!this.isNewComment) {
            this.isNewComment = true;
            this.btnText = 'Save Comment';
            this.sliderModelService.isNewCommenDlg.next(true);
            const validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
            //const selectedCompany = this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE);
            const selectedUser = validateEvolveData.resultData.find(x => x.userIdCompanyCode === '00555');

            this.newComment = [{
                date: this.datePipe.transform(new Date(), 'MM/dd/yyyy'),
                createUser: selectedUser.firstName + ' ' + selectedUser.lastName,
                comment: '',
                spendID: this.commentData.spendID,
                sequenceNumber: this.getSequenceNumber()
            }];
        } else {
            if (this.newComment[0].comment.length > 0) {
                this.resetCommentGridData();
                this.loaderService.setLoaderStatus(true);

                this.growerProgramService.saveGPSpendCommentDetails(this.newComment[0]).subscribe(result => {
                    if (result) {
                        this.loadCommentGrid();
                    }
                });
            } else {
                this.isInvalid = true;
            }

        }
    }

    private resetCommentGridData() {
        this.isNewComment = false;
        this.btnText = 'Add New Comment';
        this.sliderModelService.isNewCommenDlg.next(false);
    }

    private loadCommentGrid() {
        this.loaderService.setLoaderStatus(true);
        this.subscription.push(this.growerProgramService.getGPSpendCommentDetails(this.commentData.spendID).subscribe(result => {
            if (result) {
                this.commentDataSource = result;
            }
            this.loaderService.setLoaderStatus(false);
        }));
    }

    private getSequenceNumber() {
        if (this.commentDataSource && this.commentDataSource.length > 0) {
            return this.commentDataSource[this.commentDataSource.length - 1].sequenceNumber + 1;
        } else {
            return 1;
        }
    }

    ngOnDestroy() {
        this.subscription.forEach(subscription => subscription.unsubscribe());
    }
}
